<script lang="ts" setup>
defineProps<{
  icon: string
  label?: string
  isActive?: boolean
  isDisabled?: boolean
}>()
defineEmits<{ (e: 'click'): void }>()
</script>

<template>
  <n-tooltip trigger="hover" :delay="1000" :disabled="!label">
    <template #trigger>
      <n-button
        type="primary"
        :secondary="isActive"
        :quaternary="!isActive"
        :disabled="isDisabled"
        class="size-7"
        @click="$emit('click')"
      >
        <template #icon>
          <Icon :name="icon" />
        </template>
      </n-button>
    </template>
    {{ label }}
  </n-tooltip>
</template>
